// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__5Q6eI","validationTips":"StatementDescriptor_validationTips__JMqhf"};